import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@node_modules/@angular/forms';
import {BehaviorSubject, Observable} from '@node_modules/rxjs';
import {HttpClient} from '@node_modules/@angular/common/http';
import {Member} from '@models/member';
import {debounceTime, finalize, switchMap, tap} from '@node_modules/rxjs/internal/operators';
import {User} from '@models/user';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';

@Component({
    selector: 'app-search-people',
    templateUrl: './search-people.component.html',
    styleUrls: ['./search-people.component.scss']
})
export class SearchPeopleComponent implements OnInit {
    user: User;
    @Output() result = new EventEmitter<{ result: Member[], query: string }>();
    @Output() spinnerStartsLoading = new EventEmitter<boolean>(false);
    @Output() selectedPerson = new EventEmitter();
    @Input() direct: BehaviorSubject<string>;
    @Input() onlyStudents = false;
    @Input() programId = null;
    @Input() showResults = true;
    @Input() withLoading = true;

    searchForm: FormGroup;
    loading = true;
    personList = [];
    spinnerLoading = false;

    constructor(
        private httpClient: HttpClient,
        private authStore: Store<AuthReducer.AuthState>,
    ) {
        this.authStore.subscribe(
            (val) => {
                const auth = val.auth;
                if (auth && auth.user) {
                    this.user = auth.user;
                }
            }
        );
    }

    ngOnInit() {
        this.searchForm = new FormGroup({
            inputData: new FormControl(null)
        });
        this.direct.subscribe(
            resp => {
                if (resp === 'all') {
                    this.result.next({result: [], query: ''});
                    this.searchForm.get('inputData').reset();
                }
            });
        let stringQuery = '';
        this.searchForm
            .get('inputData')
            .valueChanges
            .pipe(
                debounceTime(300),
                tap((value) => {
                    stringQuery = value ? value : '';
                    this.result.next({result: [], query: stringQuery});
                }),
                switchMap(value => {
                        if (value) {
                            console.log('value', value);
                            return this.search(value)
                                .pipe(
                                    finalize(() => this.loading = false),
                                );
                        } else {
                            this.personList = [];
                        }
                        return new Observable(null);
                    }
                )
            )
            .subscribe((resp: { data: any }) => {
                this.spinnerLoading = false;
                if (this.showResults) {
                  this.personList = resp.data;
                }
                this.result.next({result: resp.data, query: stringQuery});
            });
    }

    selectPerson(value) {
        this.selectedPerson.next(value);
    }
    search(user_name: string) {
        const school_id = this.user.activeSchool;
        if (this.onlyStudents) {
            const body = {
                first_name: user_name
            };
            // this.store.dispatch(new StartSpinner());
            this.spinnerLoading = true;
            return this.httpClient.post(school_id + '/account/findUserByFirstName', body);
        } else {
            if (this.user.activeSchool) {
                // this.store.dispatch(new StartSpinner());
                this.spinnerLoading = true;
                this.spinnerStartsLoading.next(true);
                let query = 'school/' + school_id + '/search?user_name=' + user_name;
                if (this.programId) {
                  query += `&program_id=${this.programId}`;
                }
                return this.httpClient.get(query);
            }
        }
    }
}
